"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccumulationRuleset = getAccumulationRuleset;
const jurisdictions_1 = require("./jurisdictions");
function getAccumulationRuleset(query) {
    const { state, ...ctx } = query;
    return (0, jurisdictions_1.resolveAccumulation)(state, ctx);
}
//# sourceMappingURL=getAccumulationRuleset.js.map